import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import { API_DOMAIN } from './globals'; // Import the global domain name

function CompletedFancy() {

    const [myCompletedFancy, setCompletedFancy] = useState([]);  // Store the API response
    const [FancyPM, setFancyPM] = useState(0);

    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    const { MatchCode } = useParams();

    const formatDateWithDashes = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        // Define your parameters
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        // Create an object to pass parameters to the GET request
        const params = {
            ut: param1,
            un: param2,
            mid: MatchCode,
        };

        function getTotalFancyPM() {
            
        }

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getCompletedFancy.php?${queryString}`;

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    window.location = '/';
                } else {
                    //console.log(data.data);
                    setCompletedFancy(data.data); // Save the response data in state
                    let TotalFancyPM = 0;
                    for (let i = 0; i < data.data.length; i++) {
                        const PL = parseFloat(data.data[i]?.PL);
                        if (!isNaN(PL)) {
                            TotalFancyPM += PL;
                        }
                    }                    
                    setFancyPM(TotalFancyPM);
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });

    }, [FancyPM]);  // Empty dependency array ensures this runs only once when the component mounts

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <section className="accountste match-content">
                <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white',color:'white'}}>Completed Bet History</div>
                <div className="col-md-12"></div>
                <div id="divLoading"></div>
                <div className="appendAjaxTbl">
                    <div className="table-responsive sports-tabel">
                        <table className="table table-bordered table-hover">
                            <thead>
                                <tr className="headings" style={{ background: '#000',color:'white'}}>
                                    <th>S.No.</th>
                                    <th>RUNNER</th>
                                    <th>DATE</th>
                                    <th>RUN</th>
                                    <th>RATE</th>
                                    <th>RESULT</th>
                                    <th>AMOUNT</th>
                                    <th>MODE</th>
                                    <th>P&amp;L</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* No record found */}
                                {myCompletedFancy.length === 0 && (
                                    <tr>
                                        <th colSpan="9">No record found</th>
                                    </tr>
                                )}

                                {/* Completed Fancy Rows */}
                                {myCompletedFancy.length > 0 &&
                                    myCompletedFancy.map((row, index) => (
                                        <tr key={index} className="heading_user_table">
                                            <td style={{color:'black'}}>{index + 1}</td>
                                            <td style={{ textTransform: 'capitalize',color:'black' }}>
                                                {row.Runner.toLowerCase()}
                                            </td>
                                            <td style={{color:'black'}}>
                                                {new Date(row.Date).toLocaleString('en-US', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    hour12: true,
                                                })}
                                            </td>
                                            <td style={{color:'black'}}>{row.Run}</td>
                                            <td style={{color:'black'}}>{row.Rate}</td>
                                            <td style={{color:'black'}}>{row.Result}</td>
                                            <td style={{color:'black'}}>{row.Amount}</td>
                                            <td style={{color:'black'}}>{row.Mode}</td>
                                            <td>
                                                <span style={{ color: row.PL >= 0 ? 'green' : 'red' }}>
                                                    {row.PL}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}

                                {/* Total Plus Minus Row */}
                                {myCompletedFancy.length > 0 && (
                                    <tr>
                                        <td colSpan="8">Total Plus Minus</td>
                                        <td>
                                            <span style={{ color: FancyPM >= 0 ? 'green' : 'red' }}>
                                                {FancyPM.toFixed(2)}
                                            </span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CompletedFancy;
